'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useCallback, useEffect } from 'react';
import { useAtom } from 'jotai'

// lib files
import CompanionState from '@/lib/types/atoms/companionState';
import { getStationId } from '@/lib/profile';
import { isEmpty } from '@/lib/helpers/empty';
import { objectsMatchShallow } from '@/lib/helpers/equality';
import ReactFetchAbortError from '@/lib/errors/ReactFetchAbortError';
import { SearchFiltersObject } from '@/lib/content-services/search/search';
import { searchFiltersAtom } from '@/lib/atoms/search-filters';
import { searchResultsAtom, searchResultsStatus } from '@/lib/atoms/search-results';
import search from '@/lib/content-services/search/search';
import { SearchResults } from '@/lib/types/search/results';
import usePrevious from '@/lib/hooks/usePrevious';

function SearchRequest(props: { stationCommonName?: string, annualPassportQualifyingAmount?: number | null }) {
  const { stationCommonName, annualPassportQualifyingAmount } = props
  const [searchFilters] = useAtom(searchFiltersAtom)
  const previousFilters = usePrevious(searchFilters)
  const [_, setSearchResults] = useAtom(searchResultsAtom)
  const [resultsStatus, setResultsStatus] = useAtom(searchResultsStatus)

  const handleFilterUpdates = useCallback(async (filters: SearchFiltersObject, abortController: AbortController) => {
    if(resultsStatus === CompanionState.IsLoading) return
    setResultsStatus(CompanionState.IsLoading)

    if(!isEmpty(filters.query)) {
      const stationId = getStationId()
      let results: SearchResults | null;

      try {
        if(stationId && annualPassportQualifyingAmount !== null) {
          results = await search({ ...filters, stationId, stationCommonName, annualPassportQualifyingAmount }, { abortController })
        } else if (stationId) {
          results = await search({ ...filters, stationId, stationCommonName, }, { abortController })
        } else {
          results = await search(filters, { abortController })
        }

        if(results) {
          setSearchResults(results)
          setResultsStatus(CompanionState.IsLoadedWithData)
        } else {
          setResultsStatus(CompanionState.IsLoadedWithoutData)
        }
      } catch(_error) {
        setResultsStatus(CompanionState.Error)
      }
    }
  }, [annualPassportQualifyingAmount, stationCommonName, setSearchResults, resultsStatus, setResultsStatus])

  useEffect(() => {
    if(previousFilters && !objectsMatchShallow(searchFilters, previousFilters)) {
      const abortController = new AbortController()
      handleFilterUpdates(searchFilters, abortController)

      return () => {
        abortController.abort(new ReactFetchAbortError('Call was superceeded or component unmounted'))
      }
    }

  /*
   * We are intentially ommitting handleFilterUpdates here to prevent unnecessary rerenders
   * - Adding handleFilterUpdates to the dependency array causes the useEffect to re-run unnecessarily,
   *   which leads to the premature firing of AbortController, in turn canceling in-flight requests before they complete.
   * - Currently, handleFilterUpdates only runs when searchFilters change, which prevents redundant network calls.
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilters])

  return (<></>)
}

export default SearchRequest
